import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TipoPistaService, IRicercaTipoPistaParams } from '@app/shared/services/tipo-pista.service';

@Component({
  selector: 'ser-tipo-pista-select',
  templateUrl: './tipo-pista-select.component.html',
  styleUrl: './tipo-pista-select.component.scss'
})
export class TipoPistaSelectComponent {
  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;

  tipi: IS1InputSelectItem[];

  constructor(private tipoPistaService: TipoPistaService) { }

  ngOnInit(): void { 
    this.loadItems();
  }

  loadItems() {

    const params: IRicercaTipoPistaParams = {
      page: 1,
      pageSize: 999
    }
  
    this.tipoPistaService.ricerca(params).subscribe(tipiPistaPaginati => {
  
      this.tipi = tipiPistaPaginati?.elements?.map(tipoPista => { 
        return { code: tipoPista.id, label: tipoPista.codice?.trim() }  
      }) ?? [];
  
      if (this.tipi?.length == 1) {
        this.control?.patchValue(this.tipi[0].code);
      }
  
    })

  }

}
